import { render, staticRenderFns } from "./JVxeFileCell.vue?vue&type=template&id=3b4ac507&scoped=true"
import script from "./JVxeFileCell.vue?vue&type=script&lang=js"
export * from "./JVxeFileCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4ac507",
  null
  
)

export default component.exports